<template>
    <div class="content-page">
        <div class="container-fluid add-form-list">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between">
                            <div class="header-title">
                                <h4 class="card-title">User account deduction a user</h4>
                            </div>
                        </div>
                        <div class="card-body">
                            <!-- <form  action="#" data-toggle="validator"> -->
                                    
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>ID *</label>
                                            <input type="email" v-model="user.matricule" class="form-control" readonly placeholder="XXXXXXXX">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>First name *</label>
                                            <input type="text" v-model="user.prenoms" class="form-control" readonly placeholder="Enter libelle">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Last name *</label>
                                            <input type="text" v-model="user.nom" class="form-control" readonly placeholder="Enter libelle">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Phone *</label>
                                                <input type="text" v-model="user.phone" class="form-control" readonly placeholder="Enter libelle">                        
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>E-mail *</label>
                                                <input type="email" v-model="user.email" class="form-control" readonly placeholder="Enter libelle">                        
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Status *</label>
                                            <select name="" id="" v-model="user.status" class="form-control" readonly>
                                                <option :value="0">Extern</option>
                                                <option :value="1">Intern</option>
                                            </select>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>  
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Sold *</label>
                                            <input type="email" v-model="user.solde" class="form-control" readonly placeholder="Enter libelle">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>  
                                    <div class="col-md-6">
                                        <!-- <label>Meal type *</label> -->
                                        <div class="form-group" v-for="(quota,index) in user.quotas" :key="index">
                                            <label>{{quota.libelle}}</label>
                                            <input type="number" v-model="quota.number" class="form-control">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                        <div class="form-group">
                                            <label for="">Month</label>
                                            <input v-model="user.month" class="form-control" type="month" name="" id="">
                                        </div>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <th>TOTAL : </th>
                                                    <td> {{ total}} XOF</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>                    
                                </div>    
                                <div>
                                    <div v-if="total>0">
                                        <button  type="submit" @click="store" class="btn btn-primary mr-2">Save</button>
                                    </div>
                                    <div v-else>
                                        <button  type="submit" @click="store" disabled class="btn btn-primary mr-2">Save</button>
                                    </div>
                                    
                                </div>
                                <!-- <div v-else class="alert-danger">
                                    Insufficient balance
                                </div>                         -->
                                
                                
                            <!-- </form> -->
                        </div>
                    </div>
                    <div class="vld-parent">
                        <loading v-model:active="isLoading"
                        :can-cancel="true" 
                        :is-full-page="fullPage"></loading>
                    </div>
                </div>
            </div>
            <!-- Page end  -->
        </div>
    </div>
</template>
<script>
import axios from "axios";

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/css/index.css';
import Swal from 'sweetalert2'
export default {
    components: {
            Loading
    },
    data() {
        return {
            date: '',
            permissions: [],
            user:{},
            roles:{},
            isLoading: false,
            fullPage: true,
            // total:0
            
        };
    },
    computed:{
        total(){
            return this.user.quotas.reduce((acc, item) => acc + (Number(item.cout) * Number(item.number)), 0);
        }
    },
    mounted(){
        this.$store.state.user.permissions.forEach(element => {
            this.permissions.push(element.name)
        });
        this.getUser()
        this.user.month = new Date().getFullYear() + '01'
    },
    methods:{
        store() {
            this.isLoading = true
            let app = this
            console.log(this.user)
            axios.put('users-deduct/'+this.$route.params.id, this.user)
            .then(function (reponse) {
                app.isLoading = false
                console.log(reponse);
                if (reponse.data.status == true) {
                    Swal.fire('Success', 'User edited successfully', 'success')
                    app.$router.push('/show-user/'+app.$route.params.id)
                }
            })
            .catch(function (error) {
                app.isLoading = false
                console.log(error);
            })
        },
        getUser() {
            let app = this
            this.isLoading = true
            
            axios.get('users/'+this.$route.params.id)
            .then(response => {
                
                if (response.data.status == true) {
                    
                    response.data.data.quotas.forEach(element => {
                        element.number = 0
                    });
                    console.log(this.user)
                    app.user = response.data.data
                    app.isLoading = false
                }
            })
            .catch(error => {
                Swal.fire('error', 'An error occurred while retrieving data', 'error')
                console.log(error)
                this.errored = true
                this.isLoading = false
            })
        },
        
    }
}
</script>